import { useState, useCallback, useRef } from 'react';
import api from '../services/api';

export const useVisitorLookup = () => {
  const [visitor, setVisitor] = useState(null);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);

  const lookup = useCallback(async (phone) => {
    // Clear debounce
    if (timerRef.current) clearTimeout(timerRef.current);

    if (!phone || phone.length < 8) {
      setVisitor(null);
      return;
    }

    timerRef.current = setTimeout(async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/visitors?phone=${phone}`);
        setVisitor(data.visitors[0] || null);
      } catch {
        setVisitor(null);
      } finally {
        setLoading(false);
      }
    }, 500); // 500ms debounce
  }, []);

  const clearVisitor = useCallback(() => setVisitor(null), []);

  return { visitor, loading, lookup, clearVisitor };
};
